<template>
    <div class="announcement">
        <Header title="通知公告" :show-back="true"/>
        <div class="content">
            <h2 class="title">{{announcementObj.notice_title}}</h2>
            <h4 class="time">{{formatDate(announcementObj.create_time,2)}}</h4>
            <p class="text" v-html="announcementObj.notice_content"></p>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        components: {
            Header
        },
        data() {
            return {
                announcementObj: {}
            };
        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
                let id = this.$route.query.id;
                this.ajax.post("appapi/index/getNotice", {id: id}).then(res => {
                    if (res.data.code === 1) {
                        this.announcementObj = res.data.data;
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    .announcement {
        .content {
            margin: 35px 30px 0;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
            border-radius: 20px;
            padding: 30px;

            .title {
                font-size: 30px;
                font-weight: bold;
                color: rgba(62, 62, 62, 1);
                line-height: 67px;
                text-align: center;
            }

            .time {
                font-size: 20px;
                font-weight: 500;
                color: rgba(153, 153, 153, 1);
                line-height: 67px;
                text-align: right;
            }

            .text {
                font-size: 24px;
                font-weight: 500;
                color: rgba(62, 62, 62, 1);
                line-height: 30px;
                text-align: justify;
            }
        }
    }
</style>
